import { redirect } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import { authQueryOptions } from '@/domains/auth/queries'
import { userQueryOptions } from '@/domains/user/queries'

export const validateUserOrThrow = (queryClient: QueryClient) => {
  const authData = queryClient.getQueryData(authQueryOptions('').queryKey)
  if (!authData) {
    throw redirect({
      to: '/login',
      search: {
        redirect: location.href,
      },
    })
  }

  const userData = queryClient.getQueryData(userQueryOptions('').queryKey)
  if (!userData) {
    throw redirect({
      to: '/login',
      search: {
        redirect: location.href,
      },
    })
  }

  return { user: userData.user, accessToken: authData.access_token }
}
